import { render, staticRenderFns } from "./MultiSelectOptimized.vue?vue&type=template&id=99753e24&scoped=true"
import script from "./MultiSelectOptimized.vue?vue&type=script&lang=js"
export * from "./MultiSelectOptimized.vue?vue&type=script&lang=js"
import style0 from "./MultiSelectOptimized.vue?vue&type=style&index=0&id=99753e24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99753e24",
  null
  
)

export default component.exports